
import React, { useEffect } from "react";
import { useState } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useNavigate, useLocation, Link } from "react-router-dom";
import FailToast from "./Toast/FailToast";
import { baseUrl } from "../config";
import testtube from "../components/Images/TestTube.png";
import Loading from "./Loading/Loading";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import Intercom from "@intercom/messenger-js-sdk";
import Auth from "./Images/Auth";
import AuthButton from "./Button/AuthButton";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../features/user/userSlice";
import io from "socket.io-client";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state?.user?.user);
  const [redirectPath, setRedirectPath] = useState("");
  // const from = location.state?.from?.pathname || redirectPath;
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [activeFail, setActiveFail] = useState(false);
  const [activeSuccess, setActiveSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [user, setUser] = useState({});
  // Function to toggle password visibility

  const [value, setValue] = useState("");

  window.intercomSettings = {
    app_id: "x5w0eskb",
    custom_launcher_selector: "#help",
  };
  // const [activeSuccess, setActiveSuccess] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };



  const checkEmailVerification = async (userId) => {

    if (!userId) return;

    try {

      const response = await axios.get(`${baseUrl}/user/${userId}`);
      const isVerified = response.data.isEmailVerified;
      return isVerified;


    } catch (error) {
      console.error('Error checking verification status:', error);
      navigate('/signIN');
    }
  };

  // useEffect(() => {
  //   checkEmailVerification()
  // }, [])


  const handleVerifyEmail = async () => {
    try {
      const response = await axios.post(`${baseUrl}/verify/emailVerifyLink`, {
        email: formData.email,
      });
      console.log("response from verify email", response.data.message);
      // alert(response.data.message);
      setActiveSuccess(true);
      setValue(response.data.message);
      return;


    } catch (error) {
      console.log("Error in fetching data", error.response);
    }
  };






  // check onboarding status
  const checkOnboardStatus = async (userId) => {
    try {
      const response = await axios.get(`${baseUrl}/user/${userId}`);

      console.log("Get request successful!", response.data);
      const { onboarded } = response.data;
      let from = location.state?.from?.pathname || "";
      if (onboarded) {
        const websiteId = response.data.websites[response.data.websites.length - 1].toString();

        from = location.state?.from?.pathname || `/${websiteId}/dashboard`;
        localStorage.setItem("selectedWebsiteId", websiteId);

      } else {
        from = location.state?.from?.pathname || "/onboarding";
      }






      navigate(from, { replace: true });
      console.log("invoking navigate");
    } catch (error) {
      console.log("Error in fetching data", error.response);
    }
  };






  useEffect(() => {
    if (activeFail) {
      setTimeout(() => {
        setActiveFail(false);
      }, 3000);
    }
  }, [activeFail]);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   const emailError = validateEmail(formData.email)
  //     ? ""
  //     : "Please enter a valid email address";
  //   if (!formData.email && !formData.password) {
  //     setErrors({ email: "Please enter your email address", password: "Please enter your password" })
  //     setLoading(false);
  //     return;
  //   }

  //   if (!formData.email) {
  //     setErrors({ email: "Please enter your email address" })
  //     setLoading(false);
  //     return;
  //   }
  //   if (!formData.password) {
  //     setErrors({ password: "Please enter your password" })
  //     setLoading(false);
  //     return;
  //   }


  //   console.log("emailError", emailError);
  //   if (emailError) {
  //     setErrors({ email: emailError });

  //     setLoading(false);
  //   } else {

  //     try {
  //       // Gtag implementation
  //       setErrors({ email: "", password: "" });

  //       const response = await axios.post(`${baseUrl}/user/login`, formData);

  //       const token = response.data.token;
  //       const decoded = jwtDecode(token);
  //       const { username, userId } = decoded;
  //       localStorage.setItem("Token", response.data.token);
  //       localStorage.setItem("username", username);
  //       localStorage.setItem("userId", userId);

  //       window.dataLayer = window.dataLayer || [];
  //       window.dataLayer.push({
  //         'event': 'login',
  //         'authentication_method': 'email',
  //         'user_id': userId
  //       });

  //       setUser(response.data.user);



  //       await checkOnboardStatus(userId);
  //       setLoading(false);

  //     } catch (error) {
  //       if (error.response) {
  //         // alert("Error In Submitting: " + error.response.data.msg);
  //         // toast.error(error.response.data.msg);
  //         setActiveFail(true);
  //         setLoading(false);
  //         window.dataLayer = window.dataLayer || [];
  //         window.dataLayer.push({
  //           'event': 'website_error',
  //           'error_type': 'login error', // or registration error
  //           'error_message': 'error text' //this should be replaced with an actual message
  //         })
  //         // setValue(error.response.data.msg);
  //         if (error.response.data.type === "email")
  //           setErrors({ email: error.response.data.msg })
  //         else {
  //           setErrors({ password: error.response.data.msg })
  //         }
  //       } else {
  //         alert("Error In Submitting: " + error.message);
  //         setLoading(false);




  //       }
  //     }
  //   }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailError = validateEmail(formData.email)
      ? ""
      : "Please enter a valid email address";

    // Validate form inputs
    if (!formData.email && !formData.password) {
      setErrors({
        email: "Please enter your email address",
        password: "Please enter your password",
      });
      return;
    }

    if (!formData.email) {
      setErrors({ email: "Please enter your email address" });
      return;
    }

    if (!formData.password) {
      setErrors({ password: "Please enter your password" });
      return;
    }

    if (emailError) {
      setErrors({ email: emailError });
      return;
    }

    // Dispatch loginUser action
    // dispatch(loginUser(formData))
    //   .unwrap()
    //   .then((response) => {
    //     const { token } = response;
    //     const decoded = jwtDecode(token);
    //     const { username, userId } = decoded;
    //     console.log(response, userId, username)

    //     localStorage.setItem("Token", token);
    //     localStorage.setItem("username", username);
    //     localStorage.setItem("userId", userId);

    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push({
    //       event: "signIn",
    //       userId: userId,
    //       signInMethod: "email",
    //     });

    //      const isEmailVerified = await checkEmailVerification(userId);

    // if (!isEmailVerified) {
    //   // Send verification email
    //   await handleVerifyEmail();
    //   setLoading(false);
    //   // Navigate to verify-email with state
    //   // navigate('/verify-email', {
    //   //   state: {
    //   //     userId,
    //   //     from: location.state?.from?.pathname || '/onboarding'
    //   //   },
    //   //   replace: true
    //   // });
    //   navigate('/verify-email');
    //   return;
    // }



    //     // Handle additional post-login logic
    //     checkOnboardStatus(userId);
    //   })
    //   .catch((error) => {
    //     if (error?.response?.data?.type === "email") {
    //       setErrors({ email: error.response.data.msg });
    //     } else if (error?.response?.data?.type === "password") {
    //       setErrors({ password: error.response.data.msg });
    //     } else {
    //       alert("Error in submission: " + error.message);
    //     }
    //     setActiveFail(true);
    //   });


    try {
       const response = await axios.post(`${baseUrl}/user/login`, formData);

        const token = response.data.token;
        const decoded = jwtDecode(token);
        const { username, userId } = decoded;
 
      // const { token } = response;
      // const decoded = jwtDecode(token);
      // const { username, userId } = decoded;

      console.log(response, userId, username);

      localStorage.setItem("Token", token);
      localStorage.setItem("username", username);
      localStorage.setItem("userId", userId);

      // Push event to Google Tag Manager (or similar)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "signIn",
        userId: userId,
        signInMethod: "email",
      });

      // Call async API to check if email is verified
      const isEmailVerified = await checkEmailVerification(userId);

      if (!isEmailVerified) {
        // Send verification email
        await handleVerifyEmail();
        setLoading(false);

        // Navigate to verify-email
        navigate('/verify-email');
        return;
      }

      // Proceed to onboard if verified
      checkOnboardStatus(userId);
    } catch (error) {
      if (error?.response?.data?.type === "email") {
        setErrors({ email: error.response.data.msg });
      } else if (error?.response?.data?.type === "password") {
        setErrors({ password: error.response.data.msg });
      } else {
        alert("Error in submission: " + error.message);
      }
      setActiveFail(true);
    }




  };



  const googleLogin = useGoogleLogin({
    scope:
      "https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/user.gender.read",
    onSuccess: async ({ access_token }) => {
      try {
        console.log(access_token);
        const userInfo = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          { headers: { Authorization: `Bearer ${access_token}` } }
        );

        await GoogleSignInFunc(userInfo);
      } catch (error) {
        console.log(error);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'website_error',
          'error_type': 'login error', // or registration error
          'error_message': 'google login error' //this should be replaced with an actual message
        })
      }
    },
    onFailure: () => {
      console.log("error");
    },


  });

  const SetUser = async (response) => {
    const token = response.data.token;
    console.log(token, "this is checking ");
    const decoded = jwtDecode(token);
    const { username, userId } = decoded;
    localStorage.setItem("Token", token);
    localStorage.setItem("username", username);
    localStorage.setItem("userId", userId);



    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'login',
      'authentication_method': 'google',
      'user_id': userId
    });

    // console.log("mai mil gya", username, userId);
    setUser(response.data.user);
    if (response?.data?.user) {
      // navigate("/dashboard");
      const userId = response?.data?.user?._id;

      await checkOnboardStatus(userId);
    } else {
      console.log("error in setting user");
    }
  };

  const GoogleSignInFunc = async (userInfo) => {
    const mailCheck = await checkEmail(userInfo?.data?.email);
    if (mailCheck) {
      SetUser(mailCheck);
      return;
    }

    const googleUser = {
      firstname: userInfo?.data?.given_name,
      email: userInfo?.data?.email,
    };

    await SignUp(googleUser, "google");
    return;
  };

  const logOut = () => {
    googleLogout();
  };

  const checkEmail = async (email) => {
    try {
      const response = await axios.post(`${baseUrl}/user/checkemail`, {
        email,
      });

      if (response?.data?.success === true) {
        return response;
      }
      // console.log(response);
      return null;
    } catch (err) {
      console.log(err);
    }
  };

  const SignUp = async (socialUser, type) => {
    const config = {
      host: `${baseUrl}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": `${baseUrl}`,
      },
    };

    try {
      let response = null;
      if (type === "google") {
        response = await axios.post(
          `${baseUrl}/user/googlesignup`,
          {
            username: socialUser?.firstname,
            email: socialUser?.email,
          },
          config
        );
      }

      console.log(response);

      if (response?.data?.success === true) {
        await SetUser(response);
      } else if (response?.data?.success === false) {
        //   toast.error(response?.data?.msg, toastOption);
        console.log(response?.data?.msg);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {/* {activeFail && (
        <FailToast
          errorValue={value}
          activeFail={activeFail}
          setActiveFail={setActiveFail}
        />
      )} */}
      <div class=" flex flex-col md:flex-row w-full  h-[110vh]">
        <div class="w-full md:w-2/5 flex items-center justify-center h-screen px-6 py-4 bg-white">
          <div class="w-full max-w-md">
            <div className="pb-10 pt-16 flex justify-center items-center">
              <svg width="132" height="32" viewBox="0 0 132 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.65714 1.82857H29.2571V29.7143H3.65714V1.82857Z" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.48571C0 2.45604 2.45604 0 5.48571 0H26.5143C29.544 0 32 2.45604 32 5.48571V26.5143C32 29.544 29.544 32 26.5143 32H5.48571C2.45604 32 0 29.544 0 26.5143V5.48571ZM6.85714 7.3589C6.85714 6.37509 7.1179 5.66455 7.63942 5.22731C8.18267 4.79005 8.91063 4.57143 9.82329 4.57143H22.1768C23.1546 4.57143 23.8826 4.81192 24.3606 5.29289C24.8822 5.752 25.1429 6.44067 25.1429 7.3589C25.1429 8.29898 24.8822 8.99858 24.3606 9.4577C23.8826 9.93867 23.1546 10.1792 22.1768 10.1792H19.341C18.3197 10.201 17.4505 10.3213 16.7334 10.5399C16.0163 10.7585 15.4079 11.0537 14.9081 11.4253C14.43 11.797 14.0498 12.2342 13.7673 12.7371C13.4848 13.2399 13.2784 13.7755 13.148 14.344V10.1792H9.82329C8.84544 10.1792 8.11748 9.93867 7.63942 9.4577C7.1179 8.99858 6.85714 8.29898 6.85714 7.3589ZM18.8179 23.9196C18.8179 24.4006 18.7635 24.8597 18.6549 25.297C18.568 25.7124 18.4158 26.084 18.1985 26.412C17.9812 26.718 17.6879 26.9695 17.3185 27.1662C16.9708 27.3411 16.5362 27.4286 16.0147 27.4286C15.4932 27.4286 15.0477 27.3411 14.6783 27.1662C14.3089 26.9695 14.0047 26.718 13.7656 26.412C13.5483 26.084 13.3854 25.7124 13.2767 25.297C13.1898 24.8597 13.1463 24.4006 13.1463 23.9196V17.1641C13.1463 15.3933 13.6461 14.0269 14.6457 13.0649C15.6453 12.103 17.036 11.5892 18.8179 11.5236V23.9196Z" fill="#5049AC" />
                <path d="M51.52 8C51.7486 8 51.9467 8.02286 52.1143 8.06857C52.2971 8.11429 52.4419 8.22857 52.5486 8.41143C52.6552 8.57905 52.7086 8.85333 52.7086 9.23429C52.7086 9.61524 52.6552 9.89714 52.5486 10.08C52.4419 10.2476 52.2971 10.3543 52.1143 10.4C51.9314 10.4305 51.7257 10.4457 51.4971 10.4457H47.2914V22.6286C47.2914 22.8876 47.261 23.1238 47.2 23.3371C47.1543 23.5352 47.0324 23.6952 46.8343 23.8171C46.6514 23.939 46.339 24 45.8971 24C45.4857 24 45.181 23.9314 44.9829 23.7943C44.7848 23.6724 44.6629 23.5124 44.6171 23.3143C44.5714 23.101 44.5486 22.8648 44.5486 22.6057V10.4457H40.2971C40.0838 10.4457 39.8857 10.4229 39.7029 10.3771C39.52 10.3314 39.3676 10.2248 39.2457 10.0571C39.139 9.88952 39.0857 9.61524 39.0857 9.23429C39.0857 8.85333 39.139 8.57905 39.2457 8.41143C39.3524 8.22857 39.4971 8.11429 39.68 8.06857C39.8781 8.02286 40.0838 8 40.2971 8H51.52Z" fill="#282828" />
                <path d="M57.283 24.1371C56.2926 24.1371 55.424 23.9771 54.6773 23.6571C53.9459 23.3371 53.3288 22.9029 52.8259 22.3543C52.3383 21.7905 51.9649 21.1657 51.7059 20.48C51.4621 19.779 51.3402 19.0552 51.3402 18.3086C51.3402 17.2114 51.5916 16.2362 52.0945 15.3829C52.5973 14.5295 53.2907 13.859 54.1745 13.3714C55.0735 12.8838 56.1021 12.64 57.2602 12.64C58.083 12.64 58.8068 12.7695 59.4316 13.0286C60.0564 13.2876 60.5745 13.6305 60.9859 14.0571C61.4126 14.4686 61.7326 14.9257 61.9459 15.4286C62.1745 15.9314 62.2887 16.419 62.2887 16.8914C62.2887 17.699 62.0907 18.2857 61.6945 18.6514C61.3135 19.0171 60.8335 19.2 60.2545 19.2H54.2202C54.2354 19.7181 54.3954 20.1676 54.7002 20.5486C55.0202 20.9295 55.4164 21.2267 55.8888 21.44C56.3764 21.6381 56.8716 21.7371 57.3745 21.7371C57.7554 21.7371 58.0907 21.7143 58.3802 21.6686C58.6849 21.6229 58.944 21.5695 59.1573 21.5086C59.3707 21.4324 59.5535 21.3562 59.7059 21.28C59.8735 21.2038 60.0259 21.1352 60.163 21.0743C60.3002 21.0133 60.4297 20.9752 60.5516 20.96C60.7192 20.9448 60.8868 20.9829 61.0545 21.0743C61.2221 21.1657 61.3592 21.3257 61.4659 21.5543C61.5573 21.7067 61.6183 21.8514 61.6488 21.9886C61.6945 22.1105 61.7173 22.2324 61.7173 22.3543C61.7173 22.659 61.5345 22.9486 61.1688 23.2229C60.803 23.4819 60.2849 23.6952 59.6145 23.8629C58.9592 24.0457 58.1821 24.1371 57.283 24.1371ZM54.2202 17.5771H58.9059C59.1649 17.5771 59.363 17.539 59.5002 17.4629C59.6373 17.3714 59.7059 17.1886 59.7059 16.9143C59.7059 16.5638 59.5992 16.2514 59.3859 15.9771C59.1726 15.6876 58.883 15.4667 58.5173 15.3143C58.1516 15.1467 57.7249 15.0629 57.2373 15.0629C56.6735 15.0629 56.163 15.1771 55.7059 15.4057C55.2488 15.619 54.883 15.9162 54.6088 16.2971C54.3497 16.6781 54.2202 17.1048 54.2202 17.5771Z" fill="#282828" />
                <path d="M68.073 24.1371C67.6768 24.1371 67.2578 24.0914 66.8159 24C66.374 23.9238 65.9473 23.8095 65.5359 23.6571C65.1245 23.4895 64.7664 23.299 64.4616 23.0857C64.1721 22.8571 63.9892 22.6057 63.913 22.3314C63.8521 22.179 63.8292 22.0343 63.8445 21.8971C63.8597 21.7448 63.9054 21.5924 63.9816 21.44C64.0578 21.2724 64.1721 21.1048 64.3245 20.9371C64.4616 20.7695 64.5988 20.6781 64.7359 20.6629C64.8883 20.6324 65.0788 20.6781 65.3073 20.8C65.5054 20.8762 65.7188 20.9752 65.9473 21.0971C66.1911 21.219 66.4349 21.341 66.6788 21.4629C66.9378 21.5848 67.1968 21.6838 67.4559 21.76C67.7302 21.8362 67.9968 21.8743 68.2559 21.8743C68.8197 21.8743 69.2692 21.7829 69.6045 21.6C69.9397 21.4019 70.1073 21.1276 70.1073 20.7771C70.1073 20.579 70.054 20.4038 69.9473 20.2514C69.8407 20.099 69.6959 19.9771 69.513 19.8857C69.3454 19.779 69.1397 19.6876 68.8959 19.6114C68.6673 19.52 68.4159 19.4438 68.1416 19.3829C67.8826 19.3067 67.6083 19.2229 67.3188 19.1314C66.9378 19.0248 66.5568 18.8952 66.1759 18.7429C65.7949 18.5905 65.4521 18.3924 65.1473 18.1486C64.8578 17.9048 64.6216 17.6 64.4387 17.2343C64.2559 16.8686 64.1645 16.4114 64.1645 15.8629C64.1645 15.1771 64.3245 14.5981 64.6445 14.1257C64.9797 13.6381 65.4597 13.2648 66.0845 13.0057C66.7092 12.7467 67.4635 12.6171 68.3473 12.6171C68.6521 12.6171 68.9416 12.64 69.2159 12.6857C69.5054 12.7314 69.7797 12.8 70.0387 12.8914C70.313 12.9676 70.5721 13.0667 70.8159 13.1886C71.0749 13.3105 71.3188 13.4476 71.5473 13.6C71.9283 13.8133 72.1264 14.0648 72.1416 14.3543C72.1568 14.6286 72.0502 14.9257 71.8216 15.2457C71.654 15.459 71.4864 15.6114 71.3188 15.7029C71.1511 15.779 70.9759 15.779 70.793 15.7029C70.5492 15.581 70.2826 15.4514 69.993 15.3143C69.7188 15.1619 69.4292 15.0324 69.1245 14.9257C68.8349 14.819 68.5302 14.7657 68.2102 14.7657C67.9054 14.7657 67.6311 14.8114 67.3873 14.9029C67.1435 14.9943 66.9607 15.1238 66.8387 15.2914C66.7168 15.459 66.6559 15.6571 66.6559 15.8857C66.6559 16.099 66.7168 16.2743 66.8387 16.4114C66.9607 16.5486 67.1207 16.6629 67.3188 16.7543C67.5168 16.8457 67.753 16.9295 68.0273 17.0057C68.3016 17.0667 68.5911 17.1276 68.8959 17.1886C69.3226 17.28 69.7568 17.3943 70.1988 17.5314C70.6407 17.6686 71.0445 17.859 71.4102 18.1029C71.7911 18.3467 72.0959 18.6743 72.3245 19.0857C72.553 19.4819 72.6673 20 72.6673 20.64C72.6673 21.7524 72.2559 22.6133 71.433 23.2229C70.6254 23.8324 69.5054 24.1371 68.073 24.1371Z" fill="#282828" />
                <path d="M79.8527 24C79.106 24 78.466 23.9238 77.9327 23.7714C77.3993 23.619 76.9651 23.3829 76.6298 23.0629C76.2946 22.7429 76.0432 22.3314 75.8755 21.8286C75.7232 21.3105 75.647 20.701 75.647 20V10.3086C75.647 10.0343 75.6698 9.79809 75.7155 9.6C75.7765 9.4019 75.8984 9.24952 76.0813 9.14286C76.2793 9.02095 76.5841 8.96 76.9955 8.96C77.4222 8.96 77.727 9.02095 77.9098 9.14286C78.1079 9.26476 78.2298 9.43238 78.2755 9.64571C78.3365 9.84381 78.367 10.0648 78.367 10.3086V19.9086C78.367 20.2286 78.3898 20.4876 78.4355 20.6857C78.4965 20.8838 78.5803 21.0362 78.687 21.1429C78.8089 21.2343 78.9612 21.3029 79.1441 21.3486C79.3422 21.379 79.5784 21.3943 79.8527 21.3943C80.1422 21.3943 80.386 21.4171 80.5841 21.4629C80.7974 21.5086 80.9574 21.6229 81.0641 21.8057C81.1708 21.9733 81.2241 22.2552 81.2241 22.6514C81.2241 23.0781 81.1555 23.3905 81.0184 23.5886C80.8965 23.7714 80.7289 23.8857 80.5155 23.9314C80.3174 23.9771 80.0965 24 79.8527 24ZM74.7098 12.96L77.0641 12.9829L80.2184 12.8914C80.4774 12.8914 80.706 12.9219 80.9041 12.9829C81.1174 13.0286 81.2851 13.1505 81.407 13.3486C81.5289 13.5314 81.5898 13.8362 81.5898 14.2629C81.5898 14.659 81.5289 14.9562 81.407 15.1543C81.2851 15.3524 81.1251 15.4819 80.927 15.5429C80.7289 15.5886 80.5003 15.6114 80.2413 15.6114L77.1784 15.5657L74.6413 15.5886C74.2603 15.5733 73.9936 15.4667 73.8413 15.2686C73.7041 15.0552 73.6355 14.7124 73.6355 14.24C73.6355 13.7981 73.7193 13.4781 73.887 13.28C74.0698 13.0667 74.3441 12.96 74.7098 12.96Z" fill="#282828" />
                <path d="M95.2254 8C95.4539 8 95.652 8.02286 95.8196 8.06857C96.0025 8.11429 96.1473 8.22857 96.2539 8.41143C96.3606 8.57905 96.4139 8.85333 96.4139 9.23429C96.4139 9.61524 96.3606 9.89714 96.2539 10.08C96.1473 10.2476 96.0025 10.3543 95.8196 10.4C95.6368 10.4305 95.4311 10.4457 95.2025 10.4457H90.9968V22.6286C90.9968 22.8876 90.9663 23.1238 90.9054 23.3371C90.8596 23.5352 90.7377 23.6952 90.5396 23.8171C90.3568 23.939 90.0444 24 89.6025 24C89.1911 24 88.8863 23.9314 88.6882 23.7943C88.4901 23.6724 88.3682 23.5124 88.3225 23.3143C88.2768 23.101 88.2539 22.8648 88.2539 22.6057V10.4457H84.0025C83.7892 10.4457 83.5911 10.4229 83.4082 10.3771C83.2254 10.3314 83.073 10.2248 82.9511 10.0571C82.8444 9.88952 82.7911 9.61524 82.7911 9.23429C82.7911 8.85333 82.8444 8.57905 82.9511 8.41143C83.0577 8.22857 83.2025 8.11429 83.3854 8.06857C83.5835 8.02286 83.7892 8 84.0025 8H95.2254Z" fill="#282828" />
                <path d="M100.211 23.9771C99.5103 23.9771 98.8627 23.8552 98.2684 23.6114C97.6893 23.3524 97.1789 22.9867 96.737 22.5143C96.2951 22.0419 95.9522 21.4781 95.7084 20.8229C95.4646 20.1676 95.3427 19.4438 95.3427 18.6514V14.1029C95.3427 13.8438 95.3655 13.6152 95.4113 13.4171C95.457 13.2038 95.5789 13.0362 95.777 12.9143C95.9751 12.7924 96.2798 12.7314 96.6913 12.7314C97.1332 12.7314 97.4455 12.7924 97.6284 12.9143C97.8265 13.0362 97.9484 13.2038 97.9941 13.4171C98.0398 13.6305 98.0627 13.8667 98.0627 14.1257V18.6514C98.0627 19.2 98.1541 19.6724 98.337 20.0686C98.5351 20.4648 98.817 20.7771 99.1827 21.0057C99.5484 21.219 99.9979 21.3257 100.531 21.3257C101.08 21.3257 101.545 21.219 101.926 21.0057C102.322 20.7771 102.626 20.4648 102.84 20.0686C103.053 19.6571 103.16 19.1848 103.16 18.6514V14.08C103.16 13.821 103.183 13.5924 103.228 13.3943C103.274 13.181 103.396 13.021 103.594 12.9143C103.792 12.7924 104.105 12.7314 104.531 12.7314C104.958 12.7314 105.263 12.7924 105.446 12.9143C105.628 13.0362 105.743 13.2038 105.788 13.4171C105.849 13.6305 105.88 13.859 105.88 14.1029V22.6743C105.88 22.9029 105.849 23.1162 105.788 23.3143C105.743 23.5124 105.621 23.6724 105.423 23.7943C105.24 23.9162 104.935 23.9771 104.508 23.9771C104.204 23.9771 103.96 23.939 103.777 23.8629C103.609 23.8019 103.48 23.7181 103.388 23.6114C103.312 23.4895 103.259 23.3676 103.228 23.2457C103.213 23.1238 103.206 23.0019 103.206 22.88L103.388 22.2629C103.297 22.4 103.16 22.5676 102.977 22.7657C102.794 22.9486 102.566 23.139 102.291 23.3371C102.032 23.52 101.727 23.6724 101.377 23.7943C101.026 23.9162 100.638 23.9771 100.211 23.9771Z" fill="#282828" />
                <path d="M114.012 23.9771C113.265 23.9771 112.595 23.8324 112.001 23.5429C111.421 23.2381 110.926 22.8267 110.515 22.3086C110.119 21.7905 109.814 21.1962 109.601 20.5257C109.402 19.84 109.303 19.1086 109.303 18.3314C109.319 17.5543 109.433 16.8305 109.646 16.16C109.86 15.4743 110.164 14.88 110.561 14.3771C110.972 13.859 111.467 13.4552 112.046 13.1657C112.625 12.8762 113.281 12.7314 114.012 12.7314C114.713 12.7314 115.368 12.8762 115.978 13.1657C116.602 13.4552 117.151 13.859 117.623 14.3771C118.111 14.88 118.492 15.4743 118.766 16.16C119.041 16.8305 119.178 17.5467 119.178 18.3086C119.178 19.101 119.041 19.8476 118.766 20.5486C118.492 21.2343 118.119 21.8362 117.646 22.3543C117.174 22.8571 116.625 23.2533 116.001 23.5429C115.376 23.8324 114.713 23.9771 114.012 23.9771ZM113.646 21.3029C114.18 21.3029 114.66 21.181 115.086 20.9371C115.513 20.6781 115.848 20.3276 116.092 19.8857C116.351 19.4438 116.481 18.941 116.481 18.3771C116.481 17.7981 116.351 17.2876 116.092 16.8457C115.848 16.3886 115.513 16.0381 115.086 15.7943C114.66 15.5352 114.18 15.4057 113.646 15.4057C113.128 15.4057 112.656 15.5352 112.229 15.7943C111.802 16.0533 111.46 16.4038 111.201 16.8457C110.957 17.2876 110.835 17.7981 110.835 18.3771C110.835 18.941 110.957 19.4438 111.201 19.8857C111.46 20.3276 111.802 20.6781 112.229 20.9371C112.656 21.181 113.128 21.3029 113.646 21.3029ZM109.418 24C109.006 24 108.701 23.9314 108.503 23.7943C108.305 23.6724 108.183 23.5124 108.138 23.3143C108.092 23.101 108.069 22.8648 108.069 22.6057V8.98286C108.069 8.72381 108.092 8.49524 108.138 8.29714C108.183 8.08381 108.305 7.91619 108.503 7.79428C108.701 7.67238 109.006 7.61143 109.418 7.61143C109.844 7.61143 110.149 7.67238 110.332 7.79428C110.515 7.91619 110.629 8.08381 110.675 8.29714C110.721 8.51048 110.743 8.73905 110.743 8.98286V23.0629C110.682 23.3981 110.553 23.6343 110.355 23.7714C110.172 23.9238 109.86 24 109.418 24Z" fill="#282828" />
                <path d="M126.68 24.1371C125.69 24.1371 124.821 23.9771 124.075 23.6571C123.343 23.3371 122.726 22.9029 122.223 22.3543C121.736 21.7905 121.362 21.1657 121.103 20.48C120.859 19.779 120.738 19.0552 120.738 18.3086C120.738 17.2114 120.989 16.2362 121.492 15.3829C121.995 14.5295 122.688 13.859 123.572 13.3714C124.471 12.8838 125.499 12.64 126.658 12.64C127.48 12.64 128.204 12.7695 128.829 13.0286C129.454 13.2876 129.972 13.6305 130.383 14.0571C130.81 14.4686 131.13 14.9257 131.343 15.4286C131.572 15.9314 131.686 16.419 131.686 16.8914C131.686 17.699 131.488 18.2857 131.092 18.6514C130.711 19.0171 130.231 19.2 129.652 19.2H123.617C123.633 19.7181 123.793 20.1676 124.098 20.5486C124.418 20.9295 124.814 21.2267 125.286 21.44C125.774 21.6381 126.269 21.7371 126.772 21.7371C127.153 21.7371 127.488 21.7143 127.777 21.6686C128.082 21.6229 128.341 21.5695 128.555 21.5086C128.768 21.4324 128.951 21.3562 129.103 21.28C129.271 21.2038 129.423 21.1352 129.56 21.0743C129.697 21.0133 129.827 20.9752 129.949 20.96C130.117 20.9448 130.284 20.9829 130.452 21.0743C130.619 21.1657 130.757 21.3257 130.863 21.5543C130.955 21.7067 131.016 21.8514 131.046 21.9886C131.092 22.1105 131.115 22.2324 131.115 22.3543C131.115 22.659 130.932 22.9486 130.566 23.2229C130.2 23.4819 129.682 23.6952 129.012 23.8629C128.357 24.0457 127.579 24.1371 126.68 24.1371ZM123.617 17.5771H128.303C128.562 17.5771 128.76 17.539 128.898 17.4629C129.035 17.3714 129.103 17.1886 129.103 16.9143C129.103 16.5638 128.997 16.2514 128.783 15.9771C128.57 15.6876 128.28 15.4667 127.915 15.3143C127.549 15.1467 127.122 15.0629 126.635 15.0629C126.071 15.0629 125.56 15.1771 125.103 15.4057C124.646 15.619 124.28 15.9162 124.006 16.2971C123.747 16.6781 123.617 17.1048 123.617 17.5771Z" fill="#282828" />
              </svg>
            </div>
            <div className="">
              <AuthButton
              variant={"google"}
                // bgColor={"white"}
                id={"googleLogin"}
                onClick={googleLogin}
                text={"Sign In with Google"} icon={<svg class="w-5 h-5 mr-2" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_13183_10121)"><path d="M20.3081 10.2303C20.3081 9.55056 20.253 8.86711 20.1354 8.19836H10.7031V12.0492H16.1046C15.8804 13.2911 15.1602 14.3898 14.1057 15.0879V17.5866H17.3282C19.2205 15.8449 20.3081 13.2728 20.3081 10.2303Z" fill="#3F83F8"></path><path d="M10.7019 20.0006C13.3989 20.0006 15.6734 19.1151 17.3306 17.5865L14.1081 15.0879C13.2115 15.6979 12.0541 16.0433 10.7056 16.0433C8.09669 16.0433 5.88468 14.2832 5.091 11.9169H1.76562V14.4927C3.46322 17.8695 6.92087 20.0006 10.7019 20.0006V20.0006Z" fill="#34A853"></path><path d="M5.08857 11.9169C4.66969 10.6749 4.66969 9.33008 5.08857 8.08811V5.51233H1.76688C0.348541 8.33798 0.348541 11.667 1.76688 14.4927L5.08857 11.9169V11.9169Z" fill="#FBBC04"></path><path d="M10.7019 3.95805C12.1276 3.936 13.5055 4.47247 14.538 5.45722L17.393 2.60218C15.5852 0.904587 13.1858 -0.0287217 10.7019 0.000673888C6.92087 0.000673888 3.46322 2.13185 1.76562 5.51234L5.08732 8.08813C5.87733 5.71811 8.09302 3.95805 10.7019 3.95805V3.95805Z" fill="#EA4335"></path></g><defs><clipPath id="clip0_13183_10121"><rect width="20" height="20" fill="white" transform="translate(0.5)"></rect></clipPath></defs>
                </svg>} />
            </div>

            <form class="space-y-4 pt-4 " method="POST" action="">

              <div>
                <label for="email" class="block mb-2 text-base font-semibold text-auth-label ">Email</label>
                <input type="email" name="email" onChange={handleChange} id="email" class="bg-white border text-color-gray-light sm:text-sm rounded-lg focus:outline-none   block w-full p-3 " placeholder="Enter Email" />
                {errors.email && (
                  <p className="text-error-msg font-medium text-sm pt-2">
                    {errors.email}
                  </p>
                )}
              </div>

              {/* <div className="relative  w-full">

                <label for="password" class="block mb-2  text-base font-semibold text-auth-label">Password</label>
                <div className="relative">
                <input type={isPasswordVisible ? 'text' : 'password'} name="password" onChange={handleChange} id="password" placeholder="Enter Password" class="bg-white border focus:outline-none text-color-gray-light  sm:text-sm rounded-lg  block w-full p-3" />
                {errors.password && (
                  <p className="text-error-msg font-medium text-sm pt-2 ">
                    {errors.password}
                  </p>
                )}
                <span
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0  right-3 flex items-center cursor-pointer"
                >
                  {isPasswordVisible ? (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3334 10C13.3334 11.8409 11.841 13.3333 10 13.3333C8.15907 13.3333 6.66669 11.8409 6.66669 10C6.66669 8.15905 8.15907 6.66667 10 6.66667C11.841 6.66667 13.3334 8.15905 13.3334 10ZM11.6667 10C11.6667 10.9205 10.9205 11.6667 10 11.6667C9.07955 11.6667 8.33335 10.9205 8.33335 10C8.33335 9.07953 9.07955 8.33333 10 8.33333C10.9205 8.33333 11.6667 9.07953 11.6667 10Z" fill="#414141" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.5C14.6596 2.5 18.5749 5.68693 19.685 10C18.5749 14.3131 14.6596 17.5 10 17.5C5.34042 17.5 1.42517 14.3131 0.315063 10C1.42517 5.68693 5.34042 2.5 10 2.5ZM10 15.8333C6.27038 15.8333 3.10945 13.3818 2.04771 10C3.10945 6.61822 6.27038 4.16667 10 4.16667C13.7297 4.16667 16.8906 6.61822 17.9523 10C16.8906 13.3818 13.7297 15.8333 10 15.8333Z" fill="#414141" />
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.6986 14.047C18.8266 12.1513 20 10 20 10C20 10 16.25 3.12505 10 3.12505C8.73077 3.12505 7.56465 3.40857 6.51209 3.86047L7.47568 4.82406C8.26229 4.54152 9.10551 4.37505 10 4.37505C12.6492 4.37505 14.8487 5.83527 16.4599 7.44643C17.2546 8.24118 17.8723 9.03996 18.2909 9.64057C18.3818 9.77101 18.463 9.89156 18.5341 10C18.463 10.1085 18.3818 10.2291 18.2909 10.3595C17.8723 10.9601 17.2546 11.7589 16.4599 12.5537C16.2538 12.7597 16.0382 12.9632 15.8132 13.1616L16.6986 14.047Z" fill="#282828" />
                      <path d="M14.1218 11.4702C14.2857 11.0107 14.375 10.5158 14.375 10C14.375 7.5838 12.4162 5.62505 10 5.62505C9.48423 5.62505 8.9893 5.7143 8.52982 5.8782L9.55772 6.9061C9.70221 6.88563 9.84987 6.87505 10 6.87505C11.7259 6.87505 13.125 8.27416 13.125 10C13.125 10.1502 13.1144 10.2978 13.0939 10.4423L14.1218 11.4702Z" fill="#282828" />
                      <path d="M10.4423 13.094L11.4702 14.1219C11.0107 14.2858 10.5158 14.375 10 14.375C7.58375 14.375 5.625 12.4163 5.625 10C5.625 9.48426 5.71425 8.98933 5.87816 8.52984L6.90606 9.55774C6.88559 9.70223 6.875 9.8499 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125C10.1501 13.125 10.2978 13.1145 10.4423 13.094Z" fill="#282828" />
                      <path d="M4.1868 6.83848C3.96182 7.03684 3.74617 7.2404 3.54013 7.44643C2.74539 8.24118 2.1277 9.03996 1.70909 9.64057C1.61818 9.77101 1.53703 9.89156 1.46587 10C1.53703 10.1085 1.61818 10.2291 1.70909 10.3595C2.1277 10.9601 2.74539 11.7589 3.54013 12.5537C5.15129 14.1648 7.35077 15.625 10 15.625C10.8945 15.625 11.7377 15.4586 12.5243 15.176L13.4879 16.1396C12.4354 16.5915 11.2692 16.875 10 16.875C3.75 16.875 0 10 0 10C0 10 1.1734 7.84882 3.3014 5.95307L4.1868 6.83848Z" fill="#282828" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0581 17.942L2.05806 2.94199L2.94194 2.05811L17.9419 17.0581L17.0581 17.942Z" fill="#282828" />
                    </svg>
                  )}
                </span>
                 </div>
              </div> */}

              <div className="relative  w-full">
                <label for="password" class="block mb-2  text-base font-semibold text-auth-label">Password</label>
                <div className="relative">
                  <input type={isPasswordVisible ? 'text' : 'password'} name="password" onChange={handleChange} id="password" placeholder="Enter Password" class="bg-white border focus:outline-none text-color-gray-light  sm:text-sm rounded-lg  block w-full p-3" />
                  <span
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                  >
                    {isPasswordVisible ? (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3334 10C13.3334 11.8409 11.841 13.3333 10 13.3333C8.15907 13.3333 6.66669 11.8409 6.66669 10C6.66669 8.15905 8.15907 6.66667 10 6.66667C11.841 6.66667 13.3334 8.15905 13.3334 10ZM11.6667 10C11.6667 10.9205 10.9205 11.6667 10 11.6667C9.07955 11.6667 8.33335 10.9205 8.33335 10C8.33335 9.07953 9.07955 8.33333 10 8.33333C10.9205 8.33333 11.6667 9.07953 11.6667 10Z" fill="#414141" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.5C14.6596 2.5 18.5749 5.68693 19.685 10C18.5749 14.3131 14.6596 17.5 10 17.5C5.34042 17.5 1.42517 14.3131 0.315063 10C1.42517 5.68693 5.34042 2.5 10 2.5ZM10 15.8333C6.27038 15.8333 3.10945 13.3818 2.04771 10C3.10945 6.61822 6.27038 4.16667 10 4.16667C13.7297 4.16667 16.8906 6.61822 17.9523 10C16.8906 13.3818 13.7297 15.8333 10 15.8333Z" fill="#414141" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.6986 14.047C18.8266 12.1513 20 10 20 10C20 10 16.25 3.12505 10 3.12505C8.73077 3.12505 7.56465 3.40857 6.51209 3.86047L7.47568 4.82406C8.26229 4.54152 9.10551 4.37505 10 4.37505C12.6492 4.37505 14.8487 5.83527 16.4599 7.44643C17.2546 8.24118 17.8723 9.03996 18.2909 9.64057C18.3818 9.77101 18.463 9.89156 18.5341 10C18.463 10.1085 18.3818 10.2291 18.2909 10.3595C17.8723 10.9601 17.2546 11.7589 16.4599 12.5537C16.2538 12.7597 16.0382 12.9632 15.8132 13.1616L16.6986 14.047Z" fill="#282828" />
                        <path d="M14.1218 11.4702C14.2857 11.0107 14.375 10.5158 14.375 10C14.375 7.5838 12.4162 5.62505 10 5.62505C9.48423 5.62505 8.9893 5.7143 8.52982 5.8782L9.55772 6.9061C9.70221 6.88563 9.84987 6.87505 10 6.87505C11.7259 6.87505 13.125 8.27416 13.125 10C13.125 10.1502 13.1144 10.2978 13.0939 10.4423L14.1218 11.4702Z" fill="#282828" />
                        <path d="M10.4423 13.094L11.4702 14.1219C11.0107 14.2858 10.5158 14.375 10 14.375C7.58375 14.375 5.625 12.4163 5.625 10C5.625 9.48426 5.71425 8.98933 5.87816 8.52984L6.90606 9.55774C6.88559 9.70223 6.875 9.8499 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125C10.1501 13.125 10.2978 13.1145 10.4423 13.094Z" fill="#282828" />
                        <path d="M4.1868 6.83848C3.96182 7.03684 3.74617 7.2404 3.54013 7.44643C2.74539 8.24118 2.1277 9.03996 1.70909 9.64057C1.61818 9.77101 1.53703 9.89156 1.46587 10C1.53703 10.1085 1.61818 10.2291 1.70909 10.3595C2.1277 10.9601 2.74539 11.7589 3.54013 12.5537C5.15129 14.1648 7.35077 15.625 10 15.625C10.8945 15.625 11.7377 15.4586 12.5243 15.176L13.4879 16.1396C12.4354 16.5915 11.2692 16.875 10 16.875C3.75 16.875 0 10 0 10C0 10 1.1734 7.84882 3.3014 5.95307L4.1868 6.83848Z" fill="#282828" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0581 17.942L2.05806 2.94199L2.94194 2.05811L17.9419 17.0581L17.0581 17.942Z" fill="#282828" />
                      </svg>
                    )}
                  </span>
                </div>
                {errors.password && (
                  <p className="text-error-msg font-medium text-sm pt-2 ">
                    {errors.password}
                  </p>
                )}
              </div>



              <div class="flex items-center justify-between">
                <div class="flex items-start">

                  <Link to="/reset-password" class="  text-base font-normal text-[#111322] ">Forgot password? <span className="font-medium underline">Reset here</span></Link>

                </div>
              </div>


              <AuthButton id={"Sign in"} text={"Sign In"} loading={loading} onClick={handleSubmit} />




            </form>
            <div class="flex justify-center items-center pt-6">
              <div class="text-center font-semibold text-base text-[#7D89B0]">OR</div>

            </div>

            <div class="flex justify-center items-center pt-6">
              <Link to="/signUp">
                <div class="underline text-center font-medium text-base text-[#111322] hover: cursor-pointer">Sign Up</div>

              </Link>

            </div>

            <hr class="border-t border-gray-300 mt-4" />


            <div className=" space-y-2 mt-3">
              <p class="relative text-sm text-[#4A5578] pl-4 before:content-['•'] before:absolute before:left-0 before:text-[#4A5578]">
                By signing up, you agree to our terms of use and <a href="https://testtube.io/privacy-policy/" className="underline" target="_blank"> privacy policy</a>
              </p>
              <p class="relative text-sm text-[#4A5578] pl-4 before:content-['•'] before:absolute before:left-0 before:text-[#4A5578]">
                Sign up through your official registered email.
              </p>
              <p class="relative text-sm text-[#4A5578] pl-4 before:content-['•'] before:absolute before:left-0 before:text-[#4A5578]">
                For assistance or support, reach out to us at  <span className=" font-semibold text-[#150DF7] text-sm">support@testtube.io</span> We're here to help!.

              </p>
            </div>
          </div>
        </div>

        <div class="hidden md:block w-3/5 bg-cover bg-center">
          <Auth />
        </div>
      </div>

    </>


  );
};

export default Login;
